import { render, staticRenderFns } from "./add-node-overlay.vue?vue&type=template&id=6ff4a74e&scoped=true&"
import script from "./add-node-overlay.vue?vue&type=script&lang=ts&"
export * from "./add-node-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./add-node-overlay.vue?vue&type=style&index=0&id=6ff4a74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff4a74e",
  null
  
)

export default component.exports